<template >
  <div name="outcomegardes">
    <div class="h-90p overflow-y-auto mb-6 -ml-3" v-if="outcomesLoaded">

      <table class="table-wrapper w-full bg-white mx-auto rounded shadow-sm pb-6">
        <tbody v-for="(section, index) in outcomeSections" :key="index">
          <tr>
            <td colspan="2" class="text-sm uppercase font-bold">
              <span class="pl-3"> {{ section.value }}</span>
            </td>
          </tr>
          <tr
            v-for="(item, index) in outcomesOrderedBySection(section.key)"
            :key="index"
          >
            <td
              width="55%"
              v-bind:class="isSchoolType(item) ? 'text-pink-red' : ''"
            >
              <span
                class="text-xs italic opacity-50 mr-2 inline-block float-left h-10 pl-3"
                >{{ index + 1 }})</span
              >
              <span class="inline text-xs"> {{ item.title }}</span>

              <div class="text-right">
                <button
                  v-if="shouldShowDelete(item)"
                  @click="deleteOutcomeGrade(item)"
                  type="button"
                  class="border-none col-span-1 p-1 px-2 rounded text-xs font-medium hover:text-blue-200 focus:outline-none mr-3 text-gray-500 bg-gray-200"
                >
                  <i class="fas fa-times"></i>
                </button>

                <button
                  v-for="grade in gradesList"
                  :key="grade.key"
                  type="button"
                  @click="setOutcomeGrade(item, grade)"
                  class="border-none col-span-1 px-2 p-2 mt-1 w-28 rounded lg:mr-2 xl:mr-3 text-xs font-medium icon"
                  :class="setClass(item, grade)"
                  :style="setStyle(item, grade)"
                >
                  {{ grade.value }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
import { OutcomeService } from "@/services/outcome.service";

export default {
  name: "outcomes",
  props: {
    course: { type: Object, required: true },
    pupil: { type: Object, required: false },
    readOnly: { type: Boolean, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    outcomesLoaded() {
      return this.loading === false && this.outcomes.length > 0;
    },
    gradesList() {
      return this.settings.assessmentGradesList.filter((c) => c.used === true);
    },
    outcomesOrdered() {
      let outcomesList = this.outcomes.map((object) => {
        let result = object;
        result.criteria = result.criteria
          .replace("performance", "criteria_1")
          .replace("collaboration", "criteria_2")
          .replace("competition", "criteria_3");
        return result;
      });
      return _.orderBy(outcomesList, ["display_order", "title"]);
    },
    outcomeSections() {
      let criteriaList = this.outcomesOrdered.map((o) => o.criteria);
      let distinct = [...new Set(criteriaList)];
      var listing = distinct
        .map((x) => {
          return x
            .replace("performance", "criteria_1")
            .replace("collaboration", "criteria_2")
            .replace("competition", "criteria_3");
        })
        .sort();

      // let sections = this.settings.assessmentCriteriaList.filter((a) =>
      //   listing.includes(a.key)
      // );

      // if (sections.length === 0) {
      //   return listing.map((x) => {
      //     return { key: x, value: x.toUpperCase() };
      //   });
      // } else {
      //   return sections;
      // }
      let sections = this.settings.assessmentCriteriaList.filter((a) => a.used ).concat([{ key: "lesson", value: "Lesson" }]  )
      return sections.filter((a) => listing.includes(a.key) )


    },
    isReadOnly() {
      return this.readOnly != undefined && this.readOnly === true;
    },
  },
  data: function () {
    return {
      errored: false,
      loading: true,
      outcomes: [],
      outcomeMarks: [],
      gradesSelected: [],
      selectedPupil: undefined,
      hasMultipleSelection: true,
    };
  },
  created() {},
  mounted() {
    this.fetchOutcomes();

    if (this.pupil != undefined) {
      this.selectedPupil = this.pupil;
      this.hasMultipleSelection = false;
    }
  },
  methods: {
    shouldShowDelete(object) {
      if (this.hasMultipleSelection || this.isReadOnly) {
        return false;
      }

      return this.hasOutcome(object) != undefined;
    },
    valueExists(outcome, grade) {
      let vm = this;
      let results = vm.gradesSelected.filter(
        (o) => o.outcome_identifier === outcome.identifier
      );

      if (results.length === 0) {
        return false;
      } else {
        return results.pop().grade_score == grade.score;
      }
    },
    hasOutcome(object) {
      return this.gradesSelected.find(
        (o) => o.outcome_identifier === object.identifier
      );
    },
    setClass(object, grade) {
      if (this.valueExists(object, grade)) {
        let icon = grade.score === 4 ? "fa-star" : "fa-check-circle";
        return "text-white" + " fas " + icon;
      } else {
        let readonly = this.isReadOnly 
        ? "cursor-not-allowed" 
        : "cursor-pointer hover:text-white hover:bg-" + grade.color
        
        return  "text-gray-500 bg-gray-200 far fa-dot-circle " + readonly

      }
    },
    setStyle(object, grade) {
      if (this.valueExists(object, grade)) {
        return "background-color:#" + grade.color;
      }
    },
    isSchoolType(outcome) {
      return outcome.type_id === 3;
    },
    fetchOutcomes() {
      OutcomeService.getByCourse(this.course.id, this.settings.outcomes)
        .then((response) => this.buildOutcomes(response.data.data))
        .catch((err) => {
          console.log("Outcomes " + err);
          this.errored = true;
        });
    },
    buildOutcomes(data) {
      this.outcomes = data;
      let vm = this;

      // fetch grades
      OutcomeService.getCourseGrades(vm.course.id)
        .then((response) => (vm.outcomeMarks = response.data.data))
        .catch((err) => {
          console.log("Grades " + err);
          vm.errored = true;
        })
        .finally(() => {
          if (!vm.hasMultipleSelection) {
            let results = vm.outcomeMarks.filter(
              (o) => o.register_identifier === vm.selectedPupil.identifier
            );

            results.forEach(function (pp, index) {
              vm.gradesSelected.push({
                grade_score: pp.grade,
                outcome_identifier: pp.outcome_identifier,
              });
            });
          }
          vm.loading = false;
        });
    },
    outcomesOrderedBySection(section) {
      return this.outcomesOrdered.filter((o) => o.criteria === section);
    },
    getSectionTitle(section) {
      return section;
    },
    gradeCount(pupil) {
      return this.outcomeMarks.filter(
        (o) => o.register_identifier === pupil.identifier
      ).length;
    },
    setOutcomeGrade(object, grade) {
      if (this.isReadOnly) {  return }
      let vm = this;

      if (!vm.valueExists(object, grade)) {
        this.$emit("outcomeGradeSet", object, grade);
      }

      let found = vm.hasOutcome(object);
      if (found) {
        this.gradesSelected.splice(this.gradesSelected.indexOf(found), 1);
      }

      vm.gradesSelected.push({
        grade_score: grade.score,
        outcome_identifier: object.identifier,
      });
    },
    deleteOutcomeGrade(object) {
      let vm = this;
      let marks = this.outcomeMarks.filter(
        (o) =>
          o.outcome_identifier === object.identifier &&
          o.register_identifier === vm.selectedPupil.identifier
      );

      if (marks.length > 0) {
        vm.$emit("outcomeGradeDelete", marks.pop());

        let results = this.gradesSelected.filter(
          (o) => o.outcome_identifier === object.identifier
        );
        vm.gradesSelected.splice(vm.gradesSelected.indexOf(results.pop()), 1);
      }
    },
  },
  components: {},
};
</script>
  
  <style scoped>
</style>